import { Stack, Typography } from "@mui/material";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import GaiaSliderElement from "~/modules/app/components/GaiaSliderElement";
import SliderTextInput from "~/modules/app/components/GaiaSliderElement/SliderTextInput";

type Props<T extends FieldValues> = {
    control: Control<T>;
    minName: FieldPath<T>;
    maxName: FieldPath<T>;
    disabled?: boolean;
    label?: string;
};

export default function TemperatureRangeSlider<T extends FieldValues>({
    control,
    minName,
    maxName,
    disabled,
    label,
}: Props<T>) {
    const { t } = useTranslation("protocol");

    return (
        <GaiaSliderElement
            control={control}
            minName={minName}
            maxName={maxName}
            label={label ?? t("protocolVisitsWeatherEditor.labelTemperature")}
            min={-10}
            max={30}
            step={1}
            valueLabelDisplay="auto"
            valueLabelFormat={value => `${value} °C`}
            marks={[
                { value: -10, label: "-10°C" },
                { value: 0, label: "0°C" },
                { value: 10, label: "10°C" },
                { value: 20, label: "20°C" },
                { value: 30, label: "30°C" },
            ]}
            disabled={disabled}
            inputElement={({ min, max, step }) => (
                <Stack direction="row" gap={1}>
                    <SliderTextInput
                        control={control}
                        name={minName}
                        disabled={disabled}
                        suffix="°C"
                        min={min}
                        max={max}
                        step={step}
                    />
                    <Typography component="span">–</Typography>
                    <SliderTextInput
                        control={control}
                        name={maxName}
                        disabled={disabled}
                        suffix="°C"
                        min={min}
                        max={max}
                        step={step}
                    />
                </Stack>
            )}
        />
    );
}
